import { createContext } from 'react';

export const ProductContext = createContext({
  setProduct: product => {},
});
